var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const Svg404 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 186,
  height: 274
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "15.743%",
  x2: "124.878%",
  y1: "46.977%",
  y2: "56.742%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: "-10.987%",
  x2: "122.991%",
  y1: "-39.953%",
  y2: "134.815%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFF8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF7D50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: "49.352%",
  x2: "50.776%",
  y1: "-39.953%",
  y2: "134.815%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFF8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF7D50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: "43.025%",
  x2: "62.897%",
  y1: "-135.435%",
  y2: "77.267%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFF8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF7D50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: "49.314%",
  x2: "50.148%",
  y1: "-74.066%",
  y2: "77.267%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFF8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF7D50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: "-37.08%",
  x2: "376.842%",
  y1: "15.082%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFF8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF7D50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: "24.113%",
  x2: "93.189%",
  y1: "100%",
  y2: "-17.604%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#8F8F8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: "81.196%",
  x2: "24.959%",
  y1: "-9.23%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CFCFCF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: "18.555%",
  x2: "91.281%",
  y1: "110.449%",
  y2: "9.545%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#311B77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF2DFF"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M151.5 272.5 0 237.5 22 220l145 45.5z",
  opacity: 0.239,
  transform: "translate(-23)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "m6.362 20.633 13.35-7.678-.027-9.41-13.35 7.677z",
  transform: "translate(125)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "m6.676 111.118.406 162.793 13.351-7.677-.406-162.794z",
  transform: "translate(125)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M6.335 11.222.212 7.678.26 24.142l6.103-3.509z",
  transform: "translate(125)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#e)",
  d: "m.574 114.628.386 155.74 6.122 3.543-.406-162.793z",
  transform: "translate(125)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#f)",
  d: "M13.562 0 .212 7.678l6.123 3.544 13.35-7.678L13.564 0z",
  transform: "translate(125)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "m169.76 57-.76-.574L172.239 54l.761.574zm2.508-15.162.829.483c.297.931.38 1.953.382 2.783l-.83-.483c-.002-.83-.085-1.852-.381-2.783m-13.512 21.375-.83-.483 3.532-2.045.83.484z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m168.192 44 .83.484c.115.067.22.155.312.262.529.608.611 1.766.612 2.403l-.829-.484c-.001-.636-.084-1.794-.612-2.403a1.251 1.251 0 0 0-.313-.262"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M171.44 40.283a2.99 2.99 0 0 0-.755-.632l.83.483c.27.157.523.365.754.632.38.44.645.98.828 1.555l-.83-.483c-.183-.575-.448-1.116-.827-1.555m-9.18 11.38-.83-.483v-.065l.83.483zm-.83-.548c-.002-.874.055-1.956.563-3.082.277.16.553.322.83.483-.508 1.126-.566 2.208-.563 3.082l-.83-.483"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M161.993 48.033v-.002l.83.484-.83-.482m3.269-3.411c1.342-.777 2.307-.984 2.93-.622l.83.484c-.623-.363-1.589-.156-2.93.621-.278-.16-.554-.321-.831-.482l.83.483c-1.642.95-2.74 2.237-3.268 3.409l-.83-.484c.528-1.171 1.627-2.458 3.269-3.409"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m170.684 39.65.83.483c-1.595-.929-3.773-.092-5.434.87-1.5.867-2.784 1.892-3.841 3.068l-.83-.483c1.058-1.176 2.343-2.201 3.841-3.07 1.661-.961 3.84-1.797 5.434-.868"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "m162.239 44.07-.83-.482-.013-4.658.83.483z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m154.79 59.573-.83-.483 2.724 1.055.83.483z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M150.372 67.415c2.57-1.487 4.854-4.228 6.312-7.27l.83.483c-1.46 3.043-3.743 5.783-6.313 7.27-.277-.16-.553-.322-.83-.483"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m158.729 53.708-.83-.484v-.064l.83.483z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M148.76 68.159a9.062 9.062 0 0 0 1.612-.744c.03.017.067.04.097.056.03.019.072.042.103.06l.106.062.109.064.108.063.107.062.102.06.097.056a9.04 9.04 0 0 1-1.612.744l-.83-.483"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M148.422 68.265c.112-.032.224-.068.338-.107.275.162.552.323.829.484a7.124 7.124 0 0 1-.338.106l-.83-.483m6.352-14.782-.83-.484 2.71-4.2.83.484z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M144.707 67.961c1.01.59 2.288.713 3.715.304l.83.482c-1.428.41-2.706.287-3.715-.303l-.83-.483"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m148.027 64.1-.83-.484c.812.473 1.931.41 3.163-.304 1.48-.857 2.793-2.458 3.6-4.222l.83.483c-.807 1.764-2.12 3.365-3.6 4.221-1.233.714-2.352.778-3.163.305m5.463-11.451.83.483c.164.095.316.213.453.352l-.83-.483a2.159 2.159 0 0 0-.452-.352"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M156.652 48.8a3.86 3.86 0 0 0-.669-.493l.83.483c.238.138.462.304.669.493l-.83-.483"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m158.694 41.458-.829-.483 3.531-2.045.83.484z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M151 52.624c.964-.39 1.83-.362 2.49.023l.83.483c-.661-.384-1.527-.412-2.49-.023-.277-.16-.554-.322-.83-.483m-12.57 22.355-.83-.483 3.533-2.045.829.483z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M150.33 52.953c.228-.131.451-.24.67-.329l.83.483a5.336 5.336 0 0 0-.67.33c-2.46 1.424-4.456 4.908-4.448 7.76.003 1.427.507 2.431 1.316 2.903l-.83-.483c-.809-.472-1.312-1.477-1.316-2.903-.008-2.852 1.988-6.336 4.449-7.76"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m145.537 68.445-.83-.484c-1.449-.844-2.349-2.645-2.357-5.203l.83.483c.007 2.558.908 4.36 2.357 5.204m10.446-20.139.83.483c-1.455-.846-3.457-.734-5.664.544l-.83-.483c2.208-1.278 4.21-1.391 5.664-.544"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8C0A4",
  d: "m169.354 11.613.829.483c7.66 4.464 12.416 13.943 12.454 27.403.076 27.096-18.995 60.218-42.514 73.832l-.83-.483c23.519-13.615 42.59-46.736 42.514-73.832-.037-13.46-4.793-22.94-12.453-27.403"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8C0A4",
  d: "m109.788 116.287-.83-.483c7.76 4.521 18.5 3.895 30.336-2.956l.829.484c-11.835 6.85-22.575 7.477-30.335 2.955"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m143.18 63.242-.83-.484c-.014-5.116 3.559-11.355 7.969-13.908l.83.483c-4.411 2.553-7.983 8.793-7.969 13.909"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M108.632 115.61c.277.16.553.322.83.483.11.066.22.132.33.196l-.83-.483c-.11-.064-.22-.13-.33-.196m31.404-56.895.83.483c.873 1.157 1.065 2.89 1.07 4.166l-.83-.483c-.004-1.277-.196-3.01-1.07-4.166m-12.824 22.758-.83-.483 3.532-2.044.83.483zm9.437-19.213.417.244a5.621 5.621 0 0 0-.808-.388c.143.028.273.076.39.144"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m136.649 62.26.83.484c.115.067.22.155.312.262.528.608.61 1.766.613 2.403l-.83-.484c-.002-.636-.084-1.794-.613-2.403a1.24 1.24 0 0 0-.312-.262"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M139.897 58.543a2.995 2.995 0 0 0-.756-.635l.83.484a2.98 2.98 0 0 1 .894.807l-.83-.484a3.228 3.228 0 0 0-.138-.172M122.16 84.398l-.83-.483 3.535-2.047.83.484zm7.727-15.023c-.002-.874.055-1.957.563-3.083l.83.483c-.509 1.127-.566 2.209-.563 3.083l-.83-.483"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M130.45 66.292c.277.16.553.322.83.483-.277-.16-.553-.322-.83-.483"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M136.258 62.116c.003 0 .345.121.808.388l.412.24c-.622-.363-1.587-.156-2.93.621-.277-.16-.554-.32-.83-.482l.83.483c-1.638.949-2.737 2.234-3.268 3.408l-.83-.482c.532-1.175 1.63-2.462 3.269-3.41 1.088-.63 1.929-.885 2.54-.766"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m139.14 57.909.83.483c-1.593-.928-3.773-.091-5.434.87l-.829-.483c1.66-.961 3.84-1.8 5.434-.87"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m127.185 71.903-.83-.484c-.003-1.441.118-3.636 1.214-6.065 1.227-2.713 3.294-4.929 6.138-6.575l.83.483c-2.844 1.647-4.912 3.862-6.138 6.575-1.096 2.43-1.218 4.624-1.214 6.066"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M113.685 88.653c2.57-1.488 4.858-4.23 6.317-7.273l.83.483c-1.46 3.043-3.748 5.785-6.317 7.273a9.1 9.1 0 0 1-1.612.743l-.829-.484a9.048 9.048 0 0 0 1.611-.742"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m118.107 80.808-.83-.483 2.725 1.055.83.483z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "m118.09 74.718-.83-.483 2.71-4.2.83.483zm7.604 7.634-.83-.483-.046-16.834.829.483z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m122.112 67.565-.83-.484 3.536-2.046.829.483z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M108.02 89.197c1.09.636 2.49.73 4.054.198l.83.484c-1.564.531-2.964.437-4.054-.2l-.83-.482"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m111.345 85.337-.83-.483c.81.472 1.928.408 3.159-.305 1.484-.86 2.796-2.46 3.604-4.224l.83.483c-.808 1.764-2.12 3.365-3.605 4.224-1.231.713-2.348.777-3.158.305m5.463-11.454.83.483c.163.095.315.213.452.352l-.83-.483a2.175 2.175 0 0 0-.452-.352"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M119.97 70.035a3.884 3.884 0 0 0-.669-.493l.83.483c.238.14.461.304.668.493l-.829-.482v-.001m1.69-5.25c.426-.037.895-.192 1.387-.477l.83.483c-.492.285-.961.44-1.388.477l-.83-.483m-11.575 19.739.83.483c.131.129.275.24.43.33l-.829-.483a2.13 2.13 0 0 1-.43-.33"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "m125.833 56.001.83.483c.475.429.76 1.15.763 2.108.007 2.28-1.589 5.064-3.55 6.2l-.829-.484c1.96-1.135 3.556-3.918 3.55-6.2-.004-.958-.288-1.679-.764-2.107m-5.313 8.55c.325.189.71.271 1.14.234l.828.483a1.9 1.9 0 0 1-1.138-.234l-.83-.483"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m122.231 63.496-.829-.483c.42.245 1 .212 1.64-.159l.83.483c-.64.37-1.22.404-1.64.159m2.432-6.167.83.483c.419.244.679.765.681 1.504.004 1.48-1.03 3.284-2.303 4.021l-.83-.483c1.274-.737 2.308-2.54 2.304-4.022-.002-.738-.263-1.259-.682-1.503"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M125.833 56.001a1.715 1.715 0 0 0-.288-.21l.83.483c.102.06.198.13.288.21l-.566-.329c-.088-.051-.18-.094-.264-.154m-2.805 1.485c.637-.368 1.216-.402 1.636-.158l.83.484c-.42-.245-1-.211-1.637.158l-.83-.484"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m125.545 55.79.83.484c-.648-.377-1.54-.327-2.522.242l-.83-.484c.982-.568 1.874-.62 2.522-.241"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M120.72 61.51c-.003-1.48 1.03-3.284 2.308-4.023l.83.483c-1.278.74-2.312 2.543-2.308 4.023l-.83-.483.83.484c.002.738.262 1.259.681 1.502l-.829-.483c-.419-.244-.68-.764-.681-1.503m-7.076 12.68c1.233-.714 2.352-.78 3.162-.308l.83.483c-.81-.472-1.93-.405-3.163.309-2.46 1.424-4.453 4.906-4.445 7.759.003 1.152.332 2.03.885 2.574l-.83-.483c-.553-.544-.88-1.422-.884-2.575-.009-2.852 1.984-6.334 4.445-7.758"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m108.851 89.68-.83-.482c-1.448-.845-2.35-2.645-2.357-5.202l.83.483c.007 2.557.908 4.358 2.357 5.202m10.45-20.139.83.483c-1.455-.847-3.46-.733-5.669.546l-.83-.484c2.21-1.278 4.215-1.393 5.67-.545m2.048-4.507-.83-.484c-.645-.376-1.047-1.178-1.05-2.317-.007-2.281 1.589-5.065 3.553-6.202l.83.484c-1.965 1.137-3.56 3.92-3.554 6.201.003 1.139.405 1.941 1.05 2.318"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m106.494 84.479-.83-.483c-.014-5.117 3.562-11.358 7.969-13.909l.83.484c-4.408 2.55-7.983 8.792-7.97 13.908"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M143.364 12.306c10.102-4.663 19.185-4.655 25.983-.697l.83.483c-6.799-3.957-15.882-3.966-25.983.697-.277-.16-.553-.322-.83-.483"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M139.016 14.57a53.102 53.102 0 0 1 4.348-2.264l.83.483a53.083 53.083 0 0 0-4.349 2.264l-.83-.484"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E85127",
  d: "M96.502 88.398c-.076-27.097 18.996-60.214 42.514-73.828l.83.483c-23.52 13.614-42.591 46.731-42.514 73.828.037 13.269 4.66 22.67 12.13 27.212l-.83-.484c-7.47-4.54-12.093-13.942-12.13-27.211"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#g)",
  d: "m45.213 6.802-.205-.12c12.53-7.254 23.903-7.916 32.119-3.13l.83.484C69.74-.751 58.367-.089 45.836 7.166 20.94 21.579.75 56.645.83 85.329c.041 14.253 5.077 24.292 13.188 29.018l-.83-.484C5.078 109.137.042 99.1 0 84.846-.08 56.161 20.11 21.095 45.008 6.682l.205.12z",
  transform: "translate(94 5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#h)",
  d: "M45.535 107.742C22.016 121.356 2.82 110.387 2.743 83.29 2.666 56.195 21.738 23.077 45.257 9.463c23.518-13.615 42.715-2.65 42.791 24.446.077 27.096-18.995 60.218-42.513 73.833M45.249 6.576C20.352 20.988.16 56.055.24 84.739c.082 28.69 20.405 40.303 45.302 25.89 24.901-14.415 45.092-49.481 45.01-78.17C90.474 3.772 70.15-7.84 45.25 6.575",
  transform: "translate(94.588 5.59)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m158.756 63.213-.83-.483-.027-9.506.83.484z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#28337C",
  d: "M173.478 45.104c-.004-1.341-.216-3.187-1.209-4.338-1.597-1.841-4.247-.889-6.189.236-1.5.868-2.784 1.893-3.841 3.07l-.013-4.659-3.532 2.045.035 12.185v.065l.026 9.505 3.532-2.044v-.027l-.026-9.479v-.065c-.003-.874.054-1.957.563-3.083.526-1.173 1.626-2.46 3.267-3.41 1.593-.922 2.654-1.042 3.243-.359.528.608.61 1.766.613 2.403l.027 9.57 3.531-2.044-.027-9.57zm-32.752 13.922c-1.593-1.844-4.247-.889-6.19.236-2.843 1.646-4.91 3.862-6.137 6.575-1.096 2.43-1.218 4.624-1.214 6.066l.027 9.57 3.532-2.044-.027-9.57c-.003-.875.055-1.958.563-3.084.531-1.175 1.63-2.461 3.268-3.41 1.593-.922 2.654-1.041 3.243-.359.528.608.61 1.766.613 2.403l.027 9.57 3.53-2.044-.026-9.57c-.004-1.342-.216-3.188-1.209-4.339m-18.614 8.539.047 16.833 3.536-2.046-.048-16.834zm-7.609 17.467c-2.46 1.425-4.466.257-4.474-2.6-.008-2.852 1.984-6.334 4.445-7.758 1.484-.859 2.801-.78 3.616.044l2.71-4.2c-1.472-1.346-3.768-1.435-6.338.053-4.407 2.55-7.983 8.792-7.968 13.908.015 5.12 3.614 7.208 8.02 4.657 2.57-1.488 4.858-4.23 6.317-7.273l-2.724-1.055c-.807 1.764-2.12 3.365-3.604 4.224m36.687-21.237c-2.461 1.424-4.47.259-4.478-2.598-.008-2.852 1.988-6.336 4.448-7.76 1.48-.857 2.798-.778 3.613.045l2.709-4.2c-1.472-1.345-3.764-1.436-6.333.051-4.41 2.553-7.983 8.793-7.969 13.909.015 5.12 3.61 7.21 8.022 4.656 2.57-1.487 4.853-4.227 6.312-7.27l-2.724-1.055c-.808 1.764-2.12 3.365-3.6 4.222m-29.64-1.802c-.004-1.48 1.03-3.284 2.307-4.023 1.273-.738 2.314-.134 2.318 1.346.004 1.48-1.03 3.284-2.303 4.021-1.277.74-2.318.136-2.322-1.344m2.326 2.798c1.961-1.135 3.557-3.918 3.55-6.2-.006-2.28-1.612-3.21-3.573-2.076-1.965 1.138-3.56 3.921-3.554 6.203.007 2.28 1.612 3.21 3.577 2.073"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#i)",
  d: "M45.845 10.052C22.327 23.667 3.255 56.784 3.332 83.881c.076 27.096 19.273 38.065 42.791 24.45C69.642 94.718 88.713 61.596 88.637 34.5 88.56 7.403 69.364-3.561 45.845 10.052z",
  transform: "translate(94 5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M120.3 62.717c-.008-2.28 1.588-5.064 3.553-6.202 1.96-1.135 3.566-.205 3.573 2.077.006 2.28-1.589 5.065-3.55 6.2-1.965 1.137-3.57.207-3.577-2.075zm3.572.62c1.274-.737 2.307-2.54 2.303-4.021-.004-1.48-1.044-2.084-2.318-1.346-1.277.74-2.311 2.543-2.307 4.023.005 1.48 1.045 2.083 2.322 1.344zm46.102-6.618-.027-9.57c-.002-.637-.084-1.794-.613-2.403-.589-.683-1.65-.562-3.243.36-1.642.95-2.74 2.236-3.267 3.409-.51 1.127-.566 2.209-.564 3.083v.065l.027 9.506-3.531 2.044-.027-9.506v-.065l-.035-12.184 3.532-2.045.013 4.658c1.057-1.176 2.342-2.2 3.841-3.069 1.942-1.124 4.592-2.078 6.19-.236.992 1.15 1.204 2.996 1.208 4.338l.027 9.57-3.531 2.045zM151.2 67.899c-4.41 2.553-8.006.463-8.021-4.657-.014-5.117 3.558-11.355 7.969-13.909 2.57-1.487 4.862-1.396 6.333-.05l-2.71 4.2c-.814-.825-2.132-.903-3.612-.046-2.46 1.424-4.456 4.908-4.448 7.76.007 2.857 2.017 4.022 4.478 2.598 1.48-.857 2.792-2.458 3.6-4.222l2.724 1.055c-1.46 3.043-3.743 5.783-6.313 7.27zm-12.77 7.08-.027-9.57c-.003-.637-.084-1.794-.613-2.403-.589-.682-1.65-.562-3.243.36-1.638.948-2.737 2.235-3.268 3.409-.509 1.127-.566 2.21-.563 3.084l.027 9.57-3.532 2.044-.027-9.57c-.004-1.442.118-3.637 1.214-6.066 1.226-2.713 3.293-4.928 6.138-6.575 1.942-1.124 4.596-2.08 6.189-.236.993 1.15 1.205 2.996 1.209 4.339l.027 9.57-3.531 2.044zm-16.272 9.419-.047-16.833 3.534-2.047.048 16.834-3.535 2.046zm-7.644 4.738c-4.407 2.55-8.007.463-8.021-4.657-.015-5.116 3.561-11.357 7.968-13.908 2.57-1.488 4.866-1.4 6.337-.053l-2.709 4.2c-.815-.824-2.132-.903-3.616-.044-2.46 1.424-4.453 4.906-4.445 7.759.008 2.857 2.013 4.024 4.474 2.6 1.484-.86 2.797-2.461 3.605-4.225l2.723 1.055c-1.459 3.043-3.747 5.785-6.316 7.273z"
}))));
export default Svg404;